import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-storeaccount",
  "use": "icon-soc-m-storeaccount-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-storeaccount\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"540\" cy=\"180\" r=\"28\" /><circle cx=\"512\" cy=\"352\" r=\"128\" /><path d=\"M288 800c0-144 96-224 224-224s224 80 224 224v48H288v-48z\" /><rect x=\"640\" y=\"288\" width=\"160\" height=\"96\" rx=\"16\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-storeaccount.svg
// module id = aH2Z
// module chunks = 488